export enum ProductsEnum {
  FRECKLE = 'freckle',
  LALILO = 'lalilo',
  MYON = 'myon',
  MYON_BOOKS = 'myon_books',
  NEARPOD = 'nearpod'
}
